"use client";

import { AlertTriangle } from "lucide-react";
import { Modal } from "./Modal";
import { cn } from "../utils";

export interface PlanLimitDialogProps {
  open: boolean;
  onClose: () => void;
  resource: "vehicle" | "booking" | "customer";
  limit?: number;
  used?: number;
}

const RESOURCE_MESSAGES: Record<PlanLimitDialogProps["resource"], string> = {
  vehicle:
    "You have reached the maximum number of vehicles for your current plan.",
  booking:
    "You have reached the maximum number of bookings for your current plan.",
  customer:
    "You have reached the maximum number of customers for your current plan.",
};

export function PlanLimitDialog({
  open,
  onClose,
  resource,
  limit,
  used,
}: PlanLimitDialogProps) {
  return (
    <Modal isOpen={open} onClose={onClose} title="Plan Limit Reached" size="sm">
      <div className="flex flex-col items-center text-center gap-4">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/10">
          <AlertTriangle className="h-6 w-6 text-yellow-500" />
        </div>

        <p className="text-sm text-muted-foreground">
          {RESOURCE_MESSAGES[resource]}
        </p>

        {limit != null && used != null && (
          <div className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3">
            <p className="text-sm font-medium text-foreground">
              Used: {used} / Limit: {limit}
            </p>
          </div>
        )}

        <div className="flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-end pt-2">
          <button
            onClick={onClose}
            className="min-h-[44px] px-4 py-2.5 text-sm font-semibold text-foreground bg-muted hover:bg-muted/80 rounded-xl transition-colors"
          >
            Close
          </button>
          <button
            className={cn(
              "min-h-[44px] px-4 py-2.5 text-sm font-semibold rounded-xl transition-colors",
              "bg-primary text-primary-foreground hover:bg-primary/90"
            )}
          >
            Contact Admin
          </button>
        </div>
      </div>
    </Modal>
  );
}
